import { MantineProvider, Text } from '@mantine/core';
import Dashboard from './Dashboard';

export default function App() {
  return (
<MantineProvider theme={{colorScheme: 'dark'}} withGlobalStyles withNormalizeCSS>
        <Dashboard />
    </MantineProvider>
  );
}